var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgXBlack = function SvgXBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 24,
    r: 24,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m25.927 22.788 5.584-6.705h-1.323l-4.849 5.822-3.872-5.822H17l5.856 8.803L17 31.916h1.323l5.12-6.147 4.09 6.148H32l-6.073-9.13Zm-1.812 2.176-.594-.877-4.72-6.975h2.032l3.81 5.63.593.876 4.953 7.317h-2.033l-4.041-5.97v-.001Z",
    fill: "#363940"
  })));
};
export default SvgXBlack;